angular.module('aprima-core-ui').directive('apFullModal', function () {
    'use strict';

    return {
        restrict: 'A',
        link: function (scope, elem, attrs) {
			var header;
			var footer;
			var body;
			var modalDialog;
			var windowSelector = $(window);
			
			function updateMaxHeight(){
				var reservedSpace = 62;

				if (!body || body.length < 1) {
					header = elem.find('.modal-header');
					footer = elem.find('.modal-footer');
					body = elem.find('.modal-body');
					modalDialog = elem.closest('.modal-dialog');
				}

				if (modalDialog && modalDialog.length > 0) {
					var paddingTopStr = modalDialog.css('padding-top');
					var paddingBottomStr = modalDialog.css('padding-bottom');
					var paddingTop = parseInt(paddingTopStr);
					var paddingBottom = parseInt(paddingBottomStr);
					if (paddingTop && paddingBottom) {
						reservedSpace = 2 + paddingTop + paddingBottom;
					}
				}
				
				if(header && header.length > 0){
					reservedSpace += header.outerHeight();
				}
				
				if(footer && footer.length > 0){
					reservedSpace += footer.outerHeight();
				}
				
				var target = windowSelector.height() - reservedSpace;
				
				body.css('max-height', target + 'px');
				
				if(attrs.apFullModalAlways !== undefined){
					body.css('height', target + 'px');
				}
			}
			
			updateMaxHeight();
			
			windowSelector.on('resize', updateMaxHeight);
			var observer = new MutationObserver(updateMaxHeight);
			
			observer.observe(document.getElementsByClassName('modal')[0], {attributes: true, subtree: true, attributeFilter: ['class']});
			
			scope.$on('$destroy', function(){
				windowSelector.off('resize', updateMaxHeight);
				observer.disconnect();
			});
        }
    };
});
